import * as _types from "../_constants/types";

export const reset = () => dispatch => {
    dispatch({ type: _types.RESET });
};

export const setLanguage = language => dispatch => {
    dispatch({ type: _types.LANGUAGE_LOAD, data: language });
};

export const resetLanguage = () => dispatch => {
    dispatch({ type: _types.LANGUAGE_RESET });
};
